// extracted by mini-css-extract-plugin
module.exports = {"plain-features":"PlainFeatures_plain-features__KIusi","plain-features-block":"PlainFeatures_plain-features-block__FsIW1","description":"PlainFeatures_description__HAZIU"};